import { FavouriteLayoutModel, Value } from 'app/types-shared';
import { FavouriteDataModel } from 'app/components/favourite-layout/favourite/common/favourite-interfaces';
import { ComplexValue } from 'ui';

export interface LayoutType {
  type: Value;
  maxSelectionCriteria: number;
  default: boolean;
  allowTarget: boolean;
  allowRollingAverage: boolean;
  iconUrl: string;
  presentationType: Value;
}

export const EXECUTE_STATUS = {
  IDLE: 'idle',
  PENDING: 'pending',
  SUCCEEDED: 'succeeded',
  FAILED: 'failed'
} as const;

export type ExecuteStatus = typeof EXECUTE_STATUS[keyof typeof EXECUTE_STATUS];

export interface ChartState {
  favouriteValid: boolean;

  executeStatus: ExecuteStatus;
  executeRequestId: number;
  errorsExecuteFailed?: string[];

  // selection report data
  layoutTypes?: LayoutType[];
  selectionReport?: FavouriteDataModel;
  selectionReportLayout?: FavouriteLayoutModel;
  optionsDrillDownTo?: ComplexValue<number>[];
  fetchingOptionsDrillDownTo?: boolean;
  fetchingLayoutTypesDrillDownTo?: boolean;
  optionsLayoutTypesDrillDownTo?: LayoutType[];
}
